module.exports = __webpack_public_path__ + "static/15-e6c8c806705d3b004f743aebc5786d50.jpg";